import { FC } from 'react';

import {
  ClientModal,
  DepositModal,
  NotPermissionModal,
  ResetPasswordModal,
} from 'modals';

import { HostModals } from '../HostModals';
import { IHostPageModalsProps } from './interfaces';

export const HostPageModals: FC<IHostPageModalsProps> = ({
  notPermissionModalOpen,
  isDepositOpen,
  isResetPasswordModal,
  setIsDepositOpen,
  setIsDefaultClient,
  setCurrentClient,
  setIsResetPasswordModal,
  selectedClientUUID,
  defaultClient,
  currentClient,
  onCloseDeposit,
  onCloseResetPassword,
  onCloseClientModal,
  onCloseNotPermission,
  hostModalsState,
  refetch,
  stopPolling,
  statedPoling,
}) => {
  return (
    <>
      {notPermissionModalOpen && (
        <NotPermissionModal onClose={onCloseNotPermission} />
      )}

      {isDepositOpen && (
        <DepositModal
          defaultClientUUID={defaultClient}
          onClose={onCloseDeposit}
        />
      )}

      {isResetPasswordModal && (
        <ResetPasswordModal
          currentClient={currentClient}
          onClose={onCloseResetPassword}
          clientUUID={currentClient?.uuid}
        />
      )}

      {selectedClientUUID && !isDepositOpen && !isResetPasswordModal && (
        <ClientModal
          clientUUID={selectedClientUUID}
          onClose={onCloseClientModal}
          setIsDepositOpen={setIsDepositOpen}
          setIsDefaultClient={setIsDefaultClient}
          setIsResetPasswordModal={setIsResetPasswordModal}
          setCurrentClient={setCurrentClient}
        />
      )}

      {!isDepositOpen && (
        <HostModals
          {...hostModalsState}
          refetch={refetch}
          setIsDepositOpen={setIsDepositOpen}
          setIsDefaultClient={setIsDefaultClient}
          stopPolling={stopPolling}
          statedPoling={statedPoling}
        />
      )}
    </>
  );
};
